import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-thumb-up',
  templateUrl: './thumb-up.component.html',
  styleUrls: ['./thumb-up.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThumbUpIconComponent {}
